<template>
    <header class="head">

        <div class="wd16">
            <div class="logo">
<!--                <img alt="Vue logo" src="../assets/logo.png">-->
                <h3>主数据管理平台</h3>
            </div>
        </div>


        <div class="userinfo">
            <div>欢迎您 ! <span style="color: #efd773 ;">{{nameuser}}</span> </div>
            <div style="display: flex">
                <span style="padding: 0 10px">|</span>
                <div @click="logout" style="cursor: pointer"> 退出 </div>
            </div>

        </div>

    </header>
</template>

<script>
    import * as API from "../api/global";
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    export default {
        name: "HelloWorld",
        props: {
            msg: String,
        },
        data(){
            return {
                nameuser:'',
                affixTags:[]
            }
        },
        mounted() {
            this.nameuser=sessionStorage.getItem("loginuser")
        },
        computed:{
            ...mapState(["routerList"])
        },
        methods:{
            ...mapActions(["delAllVisitedViews"]),
            logout(){
                this.$confirm('确认退出?', '友情提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    this.getout();

                }).catch(() => {
                });

            },
            closeAllTags(view){
                this.$store.dispatch()
            },

            async getout(){
                let param = {
                    i_uid:sessionStorage.getItem("userid"),
                    token:sessionStorage.getItem("token"),
                    app: 'masterdata',
                    version: "1.0"
                };
                let res = await API.logout(param);
                if (res.code == 1) {//退出成功
                    sessionStorage.removeItem("loginuser");
                    sessionStorage.removeItem("userid");
                    sessionStorage.removeItem("token");
                    this.delAllVisitedViews();
                    this.$router.push('/login')
                } else if(res.code==-2){//身份验证失败
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else {
                    this.$message.error(res.message);
                }

            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .head {
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: #3e82e8;
        justify-content: space-between;
        height: 60px;
        color: #fff;
    }
    .wd16{
        width: 20%;
        display: flex;

        .logo{
            h3{
                margin: 0;
                width:150px;
            }
            img{
                margin: 10px;
                width: 60px;
                height: 36px;
            }
        }
    }
    .userinfo{
        display: flex;
        justify-content: space-around;
        color: #fff;
        font-size: 14px;
    }

</style>
